module.exports = __webpack_public_path__ + "media/images/policies/step2-66e7826ed9186fd9ab7ce34e65ee2584.svg";